/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBase {
    type: string;

    protected setDiscriminator(type: string) {
        this.type = type;
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationBase.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBase>): GovernanceConfigurationBase {
        let obj = Object.assign(new GovernanceConfigurationBase(), model);
        GovernanceConfigurationBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBase>): GovernanceConfigurationBase {
        if (!model) return null;
        return GovernanceConfigurationBase.newInstance(<GovernanceConfigurationBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBase) {
        if (!obj) return;

        models.GovernanceConfigurationBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBase): boolean {
        switch (obj.type)
        {
            case "GovernanceConfigurationForAIPromptAnalyticsAws":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForAIPromptAnalyticsAws.prototype);
                break;
            case "GovernanceConfigurationForAIPromptAnalyticsAzure":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForAIPromptAnalyticsAzure.prototype);
                break;
            case "GovernanceConfigurationForAIPromptAnalyticsGcp":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForAIPromptAnalyticsGcp.prototype);
                break;
            case "GovernanceConfigurationForActivityLogAws":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForActivityLogAws.prototype);
                break;
            case "GovernanceConfigurationForActivityLogAzure":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForActivityLogAzure.prototype);
                break;
            case "GovernanceConfigurationForActivityLogGcp":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForActivityLogGcp.prototype);
                break;
            case "GovernanceConfigurationForActivityLogOci":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForActivityLogOci.prototype);
                break;
            case "GovernanceConfigurationForAiGatewayAzure":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForAiGatewayAzure.prototype);
                break;
            case "GovernanceConfigurationForAiUsageBilling":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForAiUsageBilling.prototype);
                break;
            case "GovernanceConfigurationForAlertsAws":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForAlertsAws.prototype);
                break;
            case "GovernanceConfigurationForAlertsAzure":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForAlertsAzure.prototype);
                break;
            case "GovernanceConfigurationForAlertsGcp":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForAlertsGcp.prototype);
                break;
            case "GovernanceConfigurationForAlertsOci":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForAlertsOci.prototype);
                break;
            case "GovernanceConfigurationForCompliance":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForCompliance.prototype);
                break;
            case "GovernanceConfigurationForCostAnomaly":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForCostAnomaly.prototype);
                break;
            case "GovernanceConfigurationForCostRecommendationAzure":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForCostRecommendationAzure.prototype);
                break;
            case "GovernanceConfigurationForCostSavings":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForCostSavings.prototype);
                break;
            case "GovernanceConfigurationForEDPAws":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForEDPAws.prototype);
                break;
            case "GovernanceConfigurationForFreshserviceIncidentManagement":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForFreshserviceIncidentManagement.prototype);
                break;
            case "GovernanceConfigurationForGithubCopilot":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForGithubCopilot.prototype);
                break;
            case "GovernanceConfigurationForGithubProActiveScanner":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForGithubProActiveScanner.prototype);
                break;
            case "GovernanceConfigurationForJiraDataCenterIncidentManagement":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForJiraDataCenterIncidentManagement.prototype);
                break;
            case "GovernanceConfigurationForJiraServiceDeskIncidentManagement":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForJiraServiceDeskIncidentManagement.prototype);
                break;
            case "GovernanceConfigurationForJiraServiceManagementChangeManagement":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForJiraServiceManagementChangeManagement.prototype);
                break;
            case "GovernanceConfigurationForJiraServiceManagementIncidentManagement":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForJiraServiceManagementIncidentManagement.prototype);
                break;
            case "GovernanceConfigurationForKubernetesCluster":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForKubernetesCluster.prototype);
                break;
            case "GovernanceConfigurationForLogAnalyticsWorkspacesAzure":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForLogAnalyticsWorkspacesAzure.prototype);
                break;
            case "GovernanceConfigurationForMetricData":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForMetricData.prototype);
                break;
            case "GovernanceConfigurationForPatchManagementAzure":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForPatchManagementAzure.prototype);
                break;
            case "GovernanceConfigurationForPolicyAws":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForPolicyAws.prototype);
                break;
            case "GovernanceConfigurationForPolicyAzure":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForPolicyAzure.prototype);
                break;
            case "GovernanceConfigurationForSecurityRecommendationAws":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForSecurityRecommendationAws.prototype);
                break;
            case "GovernanceConfigurationForServiceNowChangeManagement":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForServiceNowChangeManagement.prototype);
                break;
            case "GovernanceConfigurationForServiceNowIncidentManagement":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForServiceNowIncidentManagement.prototype);
                break;
            case "GovernanceConfigurationForServiceNowRequestManagement":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForServiceNowRequestManagement.prototype);
                break;
            case "GovernanceConfigurationForTclItsmCmdbConfiguration":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForTclItsmCmdbConfiguration.prototype);
                break;
            case "GovernanceConfigurationForTclItsmUserConfiguration":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForTclItsmUserConfiguration.prototype);
                break;
            case "GovernanceConfigurationForThreatsAws":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForThreatsAws.prototype);
                break;
            case "GovernanceConfigurationForThreatsAzure":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForThreatsAzure.prototype);
                break;
            case "GovernanceConfigurationForThreatsGcp":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForThreatsGcp.prototype);
                break;
            case "GovernanceConfigurationForThreatsOci":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForThreatsOci.prototype);
                break;
            case "GovernanceConfigurationForVulnerabilitiesAws":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForVulnerabilitiesAws.prototype);
                break;
            case "GovernanceConfigurationForVulnerabilitiesAzure":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForVulnerabilitiesAzure.prototype);
                break;
            case "GovernanceConfigurationForVulnerabilitiesGcp":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForVulnerabilitiesGcp.prototype);
                break;
            case "GovernanceConfigurationForVulnerabilitiesOci":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForVulnerabilitiesOci.prototype);
                break;
            case "GovernanceConfigurationForZohoServiceDeskIncidentManagement":
                Object.setPrototypeOf(obj, models.GovernanceConfigurationForZohoServiceDeskIncidentManagement.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof GovernanceConfigurationBase)[] {
        return [
            models.GovernanceConfigurationForAIPromptAnalyticsAws,
            models.GovernanceConfigurationForAIPromptAnalyticsAzure,
            models.GovernanceConfigurationForAIPromptAnalyticsGcp,
            models.GovernanceConfigurationForActivityLogAws,
            models.GovernanceConfigurationForActivityLogAzure,
            models.GovernanceConfigurationForActivityLogGcp,
            models.GovernanceConfigurationForActivityLogOci,
            models.GovernanceConfigurationForAiGatewayAzure,
            models.GovernanceConfigurationForAiUsageBilling,
            models.GovernanceConfigurationForAlertsAws,
            models.GovernanceConfigurationForAlertsAzure,
            models.GovernanceConfigurationForAlertsGcp,
            models.GovernanceConfigurationForAlertsOci,
            models.GovernanceConfigurationForCompliance,
            models.GovernanceConfigurationForCostAnomaly,
            models.GovernanceConfigurationForCostRecommendationAzure,
            models.GovernanceConfigurationForCostSavings,
            models.GovernanceConfigurationForEDPAws,
            models.GovernanceConfigurationForFreshserviceIncidentManagement,
            models.GovernanceConfigurationForGithubCopilot,
            models.GovernanceConfigurationForGithubProActiveScanner,
            models.GovernanceConfigurationForJiraDataCenterIncidentManagement,
            models.GovernanceConfigurationForJiraServiceDeskIncidentManagement,
            models.GovernanceConfigurationForJiraServiceManagementChangeManagement,
            models.GovernanceConfigurationForJiraServiceManagementIncidentManagement,
            models.GovernanceConfigurationForKubernetesCluster,
            models.GovernanceConfigurationForLogAnalyticsWorkspacesAzure,
            models.GovernanceConfigurationForMetricData,
            models.GovernanceConfigurationForPatchManagementAzure,
            models.GovernanceConfigurationForPolicyAws,
            models.GovernanceConfigurationForPolicyAzure,
            models.GovernanceConfigurationForSecurityRecommendationAws,
            models.GovernanceConfigurationForServiceNowChangeManagement,
            models.GovernanceConfigurationForServiceNowIncidentManagement,
            models.GovernanceConfigurationForServiceNowRequestManagement,
            models.GovernanceConfigurationForTclItsmCmdbConfiguration,
            models.GovernanceConfigurationForTclItsmUserConfiguration,
            models.GovernanceConfigurationForThreatsAws,
            models.GovernanceConfigurationForThreatsAzure,
            models.GovernanceConfigurationForThreatsGcp,
            models.GovernanceConfigurationForThreatsOci,
            models.GovernanceConfigurationForVulnerabilitiesAws,
            models.GovernanceConfigurationForVulnerabilitiesAzure,
            models.GovernanceConfigurationForVulnerabilitiesGcp,
            models.GovernanceConfigurationForVulnerabilitiesOci,
            models.GovernanceConfigurationForZohoServiceDeskIncidentManagement,
        ];
    }

    fixupFields() {
        if (this.version_number === undefined) {
            this.version_number = 0;
        }
    }

    /**
     * Version number of this setting
     */
    version_number: number;

}
